import { render, staticRenderFns } from "./CollectionPerformanceNoResign.vue?vue&type=template&id=777cce1e&scoped=true"
import script from "./CollectionPerformanceNoResign.vue?vue&type=script&lang=js"
export * from "./CollectionPerformanceNoResign.vue?vue&type=script&lang=js"
import style0 from "./CollectionPerformanceNoResign.vue?vue&type=style&index=0&id=777cce1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777cce1e",
  null
  
)

export default component.exports